import React from 'react';

import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import MarketplaceOfferContainerManager from 'partial/OfferManager/MarketplaceOfferContainerManager';
import MarketplaceOfferCard from 'partial/OfferManager/modules/PersonalLoanHighScoreModule/OfferCard';

const OfferSummary = props => {
  return (
    <MarketplaceOfferContainerManager
      staticModules={{ modules: props.marketPlaceCards }}
      eventHandler={props.eventHandler}
      type={props.type}
      pagePosition={'OVERVIEW_PERSONAL_LOAN_OFFERS'}
      renderContainer={props.marketPlaceCards.map((item, index) => {
        return (
          <MarketplaceOfferCard
            key={index}
            tileIconKey={item.tileIconKey}
            text={item.text}
            containerClasses="margR12 margL2 pointer"
            offerModulePosition={index + 1}
            cardName={item.cardName}
            onLinkClickEvent={props.onLinkClickEvent}
            url={item.url}
            verticalTracking={item.vertical}
            location={item.location}
            modulePosition={props.modulePosition}
          />
        );
      })}
    />
  );
};

const OfferModuleView = props => {
  const {
    titleText,
    seenPixel,
    marketPlaceCards,
    onLinkClickEvent,
    eventHandler,
    subTitle,
    type,
  } = props;
  return (
    <>
      {seenPixel}
      <SectionContainer className="flex-column personalLoanHighScore-offer-container marglr20 m-marglr12">
        <Row>
          <Label type="H3 mH5">{titleText}</Label>
          <Label className="text-16 margT4 m-text-14">{subTitle}</Label>
        </Row>
        <Row className="flex-container m-items-align-center">
          <OfferSummary
            marketPlaceCards={marketPlaceCards}
            eventHandler={eventHandler}
            onLinkClickEvent={onLinkClickEvent}
            type={type}
            {...props}
          />
        </Row>
      </SectionContainer>
    </>
  );
};

export default OfferModuleView;
